
import { Vue, Component } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { brushFaceByGuarantee } from '@/api/guarantee'
@Component
export default class GuaranteeFace extends Vue {
  guaranteeId = '' // 担保函Id
  userId1 = ''
  companyId = ''
  created() {
    let { guaranteeId, userId1, companyId } = this.$route.query
    this.guaranteeId = guaranteeId as string
    this.userId1 = userId1 as string
    this.companyId = companyId as string
  }
  handleBack() {
    this.$router.go(-1)
  }
  handleBtn() {
    this.$store.state.user.info.userId = this.$route.query.opUser
    brushFaceByGuarantee({
      userId1: this.userId1,
      companyId: this.companyId,
      guaranteeId: this.guaranteeId
    })
      .then((res) => {
        if (res.code === '000000') {
          let obj = {
            opUser: this.$route.query.opUser,
            companyId: this.companyId,
            userId1: this.userId1,
            orderNo: res.data.orderNo,
            guaranteeId: this.guaranteeId
          }
          window.sessionStorage.setItem('guarantee', JSON.stringify(obj))
          window.location.href = res.data.url
        } else if (res.code === '000002') {
          this.$dialog
            .alert({
              message: res.msg
            })
            .then(() => {
              // on confirm
              this.$router.back()
            })
        } else {
          this.$toast(res.msg)
        }
      })
      .catch((res) => {
        console.log('res catch', res)

        this.$dialog
          .alert({
            message: res.msg
          })
          .then(() => {
            // on confirm
            this.$router.back()
          })
      })
    // this.$router.push({
    //   name:'GuaranteeResult',
    //   query: {
    //     success:'0'
    //   }
    // })
  }
}
